import { Component, NgZone, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatDrawer } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { FirestoreService } from 'src/app/shared/services/firestore.service';
import { UxserviceService } from 'src/app/shared/services/uxservice.service';
import { MatChip, MatChipListbox } from '@angular/material/chips';
import { EditprofileComponent } from '../editprofile/editprofile.component';
import { ImageuploadService } from 'src/app/shared/services/imageupload.service';

@Component({
  selector: 'app-profilepage',
  templateUrl: './profilepage.component.html',
  styleUrls: ['./profilepage.component.scss'],
})
export class ProfilepageComponent {
  currentuserprofile: any;
  isSubmitting = false;
  isEditing = false;
  isShowing = false;
  imageCrop: any = '';
  imageplaceholder: any = '';
  user: any = {};
  currentuserrole: any;
  currentUID: any = '';
  dobdate = new FormControl(new Date());
  userdob: any = '';
  cropperopened: boolean = false;
  userdetails: any;

  hobbies = [
    'Reading',
    'Writing',
    'Sports',
    'Cooking or Baking',
    'Gardening',
    'Photography',
    'Traveling',
    'Painting or Drawing',
    'Music',
    'Dancing',
    'Yoga and Meditation',
    'Board Games and Puzzles',
    'Fitness',
    'Fashion and Style',
    'Technology and Gadgets',
    'Movies and TV Shows',
    'Cycling',
    'Bird Watching',
    'Collecting Vinyl Records',
    'Martial Arts',
    'Sculpture',
    'Culinary Arts',
    'Sustainability',
  ];

  userinterest: any;
  constructor(
    private UXService: UxserviceService,
    public dialog: MatDialog,
    private firestoreService: FirestoreService,
    private ngZone: NgZone,
    private router: Router,
    private imageUploadService: ImageuploadService,
  ) {}

  async ngOnInit() {
    this.UXService.showOverlay('Loading');

    this.getDetails();
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.getDetails();
  }

  async getDetails() {
    await this.firestoreService.getUserDetails().then((res: any) => {
      if (res) {
        this.currentUID = res.uid;
        this.userFromFire();
        console.log(res);
      }
    });
  }

  trigger() {
    // this.communicationService.triggerMethod();
  }

  async userFromFire() {
    await this.firestoreService
      .getDocumentByIDFrom('users-list', this.currentUID)
      .then((resp) => {
        if (resp) {
          console.log(resp);

          this.user = resp;
          this.userdetails = Object.assign({}, this.user);
          console.log(this.userdetails);

          if (this.user.dob) {
            this.userdob = new Date(this.user.dob);
          }
          this.currentuserrole = this.user.role;
          this.currentuserprofile = this.user?.photoURL;
          console.log(this.currentuserrole);
        }
      });
    if (this.user?.photoURL) {
      this.imageCrop = this.user.photoURL;
      this.imageplaceholder = '';
    } else {
      this.imageplaceholder = './../../../assets/avatar.png';
      this.imageCrop = '';
    }
    this.UXService.instantCloseOverlay();
  }

  profileHandler = async (form: NgForm, e: Event) => {
    e.preventDefault();
    console.log(form);
    form.form.updateValueAndValidity();
    if (form.form.invalid) {
      console.log('form.form.invalid...');

      Object.keys(form.form.controls).forEach((key) => {
        form.form.get(key)?.markAsDirty(); //mark dirty if fields are empty
      });
    } else {
      this.isSubmitting = true;
      try {
        if (!this.cropperopened) {
          this.saveData();
        }
      } catch (e: any) {
        console.error(e.message);
        this.isSubmitting = false;
      }
    }
  };

  async saveData() {
    this.user.displayName = this.user.firstname + ' ' + this.user.lastname;
    this.isEditing = false;
    if (this.userdob) {
      this.user.dob = this.userdob.getTime();
    }
    // this.UXService.showOverlay('Saving data');
    console.log();

    await this.firestoreService
      .updateAuthDetails('displayName', this.user.displayName)
      .then(async (res) => {
        await this.firestoreService
          .updateDocumentWithIDOF('users-list', this.currentUID, this.user)
          .then((res) => {
            this.UXService.openSnackBar('Profile updated !', 'OK');
          });
        this.getDetails();
        this.UXService.instantCloseOverlay();
        this.isSubmitting = false;
      });
  }

  closeProfile() {
    this.isEditing = false;
  }
  //     showCustomCropperDialog() {
  //       console.log(this.cropperopened);

  //       this.cropperopened=true
  // console.log("sshbss");

  //       const dialogRef = this.dialog.open(ImagecropperComponent,
  //         {
  //           data: {
  //             height: 200,
  //             width: 200,
  //             shape: true,
  //             placeholder: "./../../../assets/avatar.png",
  //             image: this.imageCrop,
  //             heading: "Update Profile",

  //             currentuid: this.currentUID,
  //             bucketName: this.currentUID,
  //             bucketFolder: 'profile'
  //           },
  //           width: "650px",
  //           maxWidth: "80vw",
  //           disableClose: true,
  //           panelClass: 'profileimagemodal'

  //         });
  //       dialogRef.afterClosed().subscribe((res) => {

  //         if (res) {

  //           this.updateImageUrl(res);
  //         }
  //         else{
  //           this.cropperopened=false;
  //         }
  //       })
  //     }

  async updateImageUrl(url: string) {
    if (url == 'delete') {
      this.user.photoURL = '';
      this.imageplaceholder = './../../../../assets/testimgs/avatar.png';
      this.imageCrop = '';
    } else {
      this.user.photoURL = url;
      this.imageplaceholder = '';
      this.imageCrop = url;
    }

    this.UXService.showOverlay('Rendering photo');
    try {
      await this.firestoreService
        .updateAuthDetailsImg(url)
        .then(async (res) => {
          await this.firestoreService.updateDocumentWithIDOF(
            `users-list`,
            this.currentUID,
            {
              photoURL: this.user.photoURL,
            },
          );
          this.UXService.instantCloseOverlay();
          this.UXService.openSnackBar('Image updated !', 'OK');
          this.isSubmitting = false;
        });
    } catch (e: any) {
      this.UXService.instantCloseOverlay();
      this.UXService.openSnackBar(e, 'OK');
      this.isSubmitting = false;
    }
    this.cropperopened = false;
  }

  onLogoClick() {
    const fileInput = document.getElementById('logoInput') as HTMLElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  async onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      this.UXService.showOverlay('Uploading Logo...');
      try {
        const url = await this.imageUploadService.upload(
          'profile-logos',
          this.currentUID,
          file,
        );
        if (url) {
          await this.updateImageUrl(url);
        }
      } catch (error) {
        console.error(error);
        this.UXService.openSnackBar('Error uploading logo: ' + error, 'Close');
        this.UXService.instantCloseOverlay();
      }
    }
  }

  editCompanydetails() {
    const dialogRef = this.dialog.open(EditprofileComponent, {
      // height:  'calc(100vh - 65px)',
      width: 'calc(100vh - 65px)',
      // position: { right: '0px', bottom: '0px' },
      hasBackdrop: true,
      panelClass: 'docdetail',
      data: {
        fromwhere: 'companyprofile',

        userdetails: this.userdetails,
        bywhom: this.userdetails.id,
        bywhomname: this.userdetails.displayName,
      },
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      console.log(result);
      if (!result) {
        return;
      } else {
        console.log(result);
        // return
        this.user = result;

        // this.saveContractorProjects(result)
        this.UXService.showOverlay('Updating projects');

        this.saveData();
        this.dialog.closeAll();
      }
    });
  }
  editprofiledetails() {
    const dialogRef = this.dialog.open(EditprofileComponent, {
      // height:  'calc(100vh - 65px)',
      width: 'calc(100vh - 65px)',
      // height:'50%',
      // position: { right: '0px', bottom: '0px' },
      hasBackdrop: true,
      panelClass: 'docdetail',
      data: {
        fromwhere: 'userprofile',
        userdetails: this.userdetails,
        bywhom: this.userdetails.id,
        bywhomname: this.userdetails.displayName,
      },
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      console.log(result);
      if (!result) {
        return;
      } else {
        console.log(result);
        // return
        // this.saveContractorProjects(result)
        this.user = result;
        this.UXService.showOverlay('Updating projects');
        this.saveData();
        this.dialog.closeAll();
      }
    });
  }
}
